import * as React from 'react'
import { Box, Container, Typography, Stack } from '@mui/material'

/**
 * TitleBar component for displaying a section header with a title and action buttons.
 */
const TitleBar = ({ title, actions = [] }) => {
  return (
    <Box sx={{ bgcolor: 'brand.light', borderBottom: '1px solid', borderColor: 'divider' }}>
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
          py: 3,
        }}
      >
        {/* Left Content */}
        <Box>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 'fontWeightMedium' }}>
            {title}
          </Typography>
        </Box>

        {/* Right Content */}
        <Box>
          <Stack direction="row" spacing={2}>
            {actions.map((action, index) => (
              <React.Fragment key={index}>{action}</React.Fragment>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}

export default TitleBar
